import { ServerRoutes, routePrefix } from "@rinastyling/common";
import { appConfig } from "../utils/appConfig";

import { getAuthCookie } from "../actions/initServerPage.action";

export class ServerService {
  private baseURL: string;
  constructor(inRoute?: ServerRoutes) {
    this.baseURL = `${appConfig.baseUrl}${routePrefix}${
      inRoute ? inRoute + "/" : ""
    }`;
  }
  private async getHeaders(): Promise<HeadersInit> {
    const cookie = await getAuthCookie();
    const cookieHeader = typeof window === "undefined" ? { cookie } : {};
    return {
      ...cookieHeader
    } as HeadersInit;
  }

  protected typedFetch = async <
    Req,
    Res,
    Query extends Record<string, string> = Record<string, string>
  >(
    url: string,
    options?: Omit<RequestInit, "body"> & { body?: Req },
    query?: Query
  ): Promise<Res> => {
    try {
      const isFormData = options?.body instanceof FormData;
      if (query) url += `?${new URLSearchParams(query).toString()}`;
      const headers = await this.getHeaders();

      const fetchOptions: RequestInit = {
        ...options,
        credentials: "include",
        headers: {
          ...headers,
          // The browser automatically sets the correct Content-Type for FormData
          // So, we should not manually set it to 'application/json'
          ...(!isFormData && { "Content-Type": "application/json" }),
          ...options?.headers
        },
        // The body is either the raw FormData object or a stringified JSON object
        body: isFormData
          ? (options.body as BodyInit)
          : options?.body
          ? JSON.stringify(options.body)
          : undefined
      };

      const response = await fetch(`${this.baseURL}${url}`, fetchOptions);
      const contentType = response.headers.get("content-type");
      if (contentType?.includes("application/json")) {
        const json = await response.json();
        return json as Res;
      } else if (
        contentType?.includes("text/csv") ||
        contentType?.includes("application/octet-stream")
      ) {
        // For CSV/blob, return the response itself or its blob()
        return response as Res;
      } else {
        // Fallback for other content types
        return response.text() as Res;
      }
    } catch (error) {
      console.error(
        "error on typed fetch",
        url,
        JSON.stringify(options ?? {}, null, 2),
        JSON.stringify(query ?? {}, null, 2)
      );
      console.error(error);
      throw error;
    }
  };

  // eslint-disable-next-line @typescript-eslint/ban-types
  protected fileFormDataBuilder(body: Object) {
    const data = new FormData();

    const keys = Object.keys(body) as unknown as keyof typeof body;
    console.log(keys);

    for (const key of keys) {
      const k = key as keyof typeof body;
      const value = body[k];
      const isUndefinedOrNull = value === undefined || value === null;
      if (isUndefinedOrNull) continue;

      const isFile = value instanceof File;
      if (isFile) {
        data.append(k, value);
        continue;
      }
      if (typeof value === "string") {
        data.append(k, value);
        continue;
      }

      data.append(k, JSON.stringify(value));
    }
    return data;
  }
}
